import React from 'react';
import { Container, Paper, Box, Typography } from '@mui/material';
import ResetPasswordForm from '../components/auth/ResetPasswordForm';
import TimeDisplay from '../components/TimeDisplay';
import ThemeToggle from '../components/ThemeToggle';

const ResetPasswordPage: React.FC = () => {
  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, px: 2 }}>
        <TimeDisplay />
        <ThemeToggle />
      </Box>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Reset Password
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Create a new password for your account
          </Typography>
        </Box>
        <ResetPasswordForm />
      </Paper>
    </Container>
  );
};

export default ResetPasswordPage;
